<template>
  <q-dialog v-model="shown">
    <q-card style="width: 400px;">
      <q-card-section class="row items-center q-mx-xs">
        <div class="text-h6">
          Select Modifier Sets
        </div>
        <q-space />
        <q-btn
          v-close-popup
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>
      <q-card-section>
        <q-list
          bordered
          separator
        >
          <q-item
            v-for="modifierSet in $_.filter(modifierSets.data, { archivedAt: null })"
            :key="modifierSet.id"

            :class="{ 'bg-grey-3': item.hasSavedModifierSet(modifierSet) }"
            clickable
            @click="toggle(modifierSet)"
          >
            <q-item-section>
              <q-checkbox
                :model-value="item.hasModifierSet(modifierSet)"
                :disabled="item.hasSavedModifierSet(modifierSet)"
                :label="modifierSet.name"
                style="pointer-events: none;"
              />
            </q-item-section>
          </q-item>
        </q-list>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>

import Item from 'src/models/item/Item'

export default {
  name: 'SelectModifierSetsDialog',
  props: {
    modelValue: {
      type: Boolean,
      required: false
    },
    item: {
      type: Item,
      required: true
    }
  },
  emits: ['update:model-value', 'change'],
  data () {
    return {
      shown: false
    }
  },
  computed: {
  },
  watch: {
    modelValue () {
      this.shown = this.modelValue
    },
    shown () {
      this.$emit('update:model-value', this.shown)
    }
  },
  methods: {
    show () {
      this.shown = true
    },
    toggle (modifierSet) {
      if (this.item.hasSavedModifierSet(modifierSet)) {
        return
      }

      if (this.item.hasModifierSet(modifierSet)) {
        // Remove
        this.item.removeModifierSet(modifierSet)
      } else {
        // Add
        this.item.addModifierSet(modifierSet)
      }

      this.$emit('change')
    }
  },
  configuration: ['modifierSets']
}

</script>

<style lang="scss" scoped>
</style>
